// GENERATED FILE — do not edit by hand.
// Source: EPA "2027 EPCRA Hazard Categories and OSHA Hazard Category Crosswalk" (May 2026).
// Regenerate with packages/encamp-shared/src/hazards/scripts/generate-hazard-categories.ts, which also
// emits the HazardCategory seed for the migration so the two cannot drift.

import type { HazardCategory } from "encamp-prisma/generated/browser";

export type HazardCategoryRow = HazardCategory;

export const HAZARD_CATEGORIES = [
  {
    code: "ACUTE_TOXICITY_ORAL",
    label: "Acute Toxicity, Oral",
    hazardType: "HEALTH",
    parentCode: null,
    selectable: false,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "ACUTE_TOXICITY",
    crosswalkNote: null,
  },
  {
    code: "ACUTE_TOXICITY_ORAL_CATEGORY_1",
    label: "Acute Toxicity, Oral – Category 1",
    hazardType: "HEALTH",
    parentCode: "ACUTE_TOXICITY_ORAL",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "ACUTE_TOXICITY",
    crosswalkNote: null,
  },
  {
    code: "ACUTE_TOXICITY_ORAL_CATEGORY_2",
    label: "Acute Toxicity, Oral – Category 2",
    hazardType: "HEALTH",
    parentCode: "ACUTE_TOXICITY_ORAL",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "ACUTE_TOXICITY",
    crosswalkNote: null,
  },
  {
    code: "ACUTE_TOXICITY_ORAL_CATEGORY_3",
    label: "Acute Toxicity, Oral – Category 3",
    hazardType: "HEALTH",
    parentCode: "ACUTE_TOXICITY_ORAL",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "ACUTE_TOXICITY",
    crosswalkNote: null,
  },
  {
    code: "ACUTE_TOXICITY_ORAL_CATEGORY_4",
    label: "Acute Toxicity, Oral – Category 4",
    hazardType: "HEALTH",
    parentCode: "ACUTE_TOXICITY_ORAL",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "ACUTE_TOXICITY",
    crosswalkNote: null,
  },
  {
    code: "ACUTE_TOXICITY_DERMAL",
    label: "Acute Toxicity, Dermal",
    hazardType: "HEALTH",
    parentCode: null,
    selectable: false,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "ACUTE_TOXICITY",
    crosswalkNote: null,
  },
  {
    code: "ACUTE_TOXICITY_DERMAL_CATEGORY_1",
    label: "Acute Toxicity, Dermal – Category 1",
    hazardType: "HEALTH",
    parentCode: "ACUTE_TOXICITY_DERMAL",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "ACUTE_TOXICITY",
    crosswalkNote: null,
  },
  {
    code: "ACUTE_TOXICITY_DERMAL_CATEGORY_2",
    label: "Acute Toxicity, Dermal – Category 2",
    hazardType: "HEALTH",
    parentCode: "ACUTE_TOXICITY_DERMAL",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "ACUTE_TOXICITY",
    crosswalkNote: null,
  },
  {
    code: "ACUTE_TOXICITY_DERMAL_CATEGORY_3",
    label: "Acute Toxicity, Dermal – Category 3",
    hazardType: "HEALTH",
    parentCode: "ACUTE_TOXICITY_DERMAL",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "ACUTE_TOXICITY",
    crosswalkNote: null,
  },
  {
    code: "ACUTE_TOXICITY_DERMAL_CATEGORY_4",
    label: "Acute Toxicity, Dermal – Category 4",
    hazardType: "HEALTH",
    parentCode: "ACUTE_TOXICITY_DERMAL",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "ACUTE_TOXICITY",
    crosswalkNote: null,
  },
  {
    code: "ACUTE_TOXICITY_INHALATION_GASES",
    label: "Acute Toxicity, Inhalation – Gases",
    hazardType: "HEALTH",
    parentCode: null,
    selectable: false,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "ACUTE_TOXICITY",
    crosswalkNote: null,
  },
  {
    code: "ACUTE_TOXICITY_INHALATION_GASES_CATEGORY_1",
    label: "Acute Toxicity, Inhalation – Gases – Category 1",
    hazardType: "HEALTH",
    parentCode: "ACUTE_TOXICITY_INHALATION_GASES",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "ACUTE_TOXICITY",
    crosswalkNote: null,
  },
  {
    code: "ACUTE_TOXICITY_INHALATION_GASES_CATEGORY_2",
    label: "Acute Toxicity, Inhalation – Gases – Category 2",
    hazardType: "HEALTH",
    parentCode: "ACUTE_TOXICITY_INHALATION_GASES",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "ACUTE_TOXICITY",
    crosswalkNote: null,
  },
  {
    code: "ACUTE_TOXICITY_INHALATION_GASES_CATEGORY_3",
    label: "Acute Toxicity, Inhalation – Gases – Category 3",
    hazardType: "HEALTH",
    parentCode: "ACUTE_TOXICITY_INHALATION_GASES",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "ACUTE_TOXICITY",
    crosswalkNote: null,
  },
  {
    code: "ACUTE_TOXICITY_INHALATION_GASES_CATEGORY_4",
    label: "Acute Toxicity, Inhalation – Gases – Category 4",
    hazardType: "HEALTH",
    parentCode: "ACUTE_TOXICITY_INHALATION_GASES",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "ACUTE_TOXICITY",
    crosswalkNote: null,
  },
  {
    code: "ACUTE_TOXICITY_INHALATION_VAPORS",
    label: "Acute Toxicity, Inhalation – Vapors",
    hazardType: "HEALTH",
    parentCode: null,
    selectable: false,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "ACUTE_TOXICITY",
    crosswalkNote: null,
  },
  {
    code: "ACUTE_TOXICITY_INHALATION_VAPORS_CATEGORY_1",
    label: "Acute Toxicity, Inhalation – Vapors – Category 1",
    hazardType: "HEALTH",
    parentCode: "ACUTE_TOXICITY_INHALATION_VAPORS",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "ACUTE_TOXICITY",
    crosswalkNote: null,
  },
  {
    code: "ACUTE_TOXICITY_INHALATION_VAPORS_CATEGORY_2",
    label: "Acute Toxicity, Inhalation – Vapors – Category 2",
    hazardType: "HEALTH",
    parentCode: "ACUTE_TOXICITY_INHALATION_VAPORS",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "ACUTE_TOXICITY",
    crosswalkNote: null,
  },
  {
    code: "ACUTE_TOXICITY_INHALATION_VAPORS_CATEGORY_3",
    label: "Acute Toxicity, Inhalation – Vapors – Category 3",
    hazardType: "HEALTH",
    parentCode: "ACUTE_TOXICITY_INHALATION_VAPORS",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "ACUTE_TOXICITY",
    crosswalkNote: null,
  },
  {
    code: "ACUTE_TOXICITY_INHALATION_VAPORS_CATEGORY_4",
    label: "Acute Toxicity, Inhalation – Vapors – Category 4",
    hazardType: "HEALTH",
    parentCode: "ACUTE_TOXICITY_INHALATION_VAPORS",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "ACUTE_TOXICITY",
    crosswalkNote: null,
  },
  {
    code: "ACUTE_TOXICITY_INHALATION_DUSTS_AND_MISTS",
    label: "Acute Toxicity, Inhalation – Dusts and Mists",
    hazardType: "HEALTH",
    parentCode: null,
    selectable: false,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "ACUTE_TOXICITY",
    crosswalkNote: null,
  },
  {
    code: "ACUTE_TOXICITY_INHALATION_DUSTS_AND_MISTS_CATEGORY_1",
    label: "Acute Toxicity, Inhalation – Dusts and Mists – Category 1",
    hazardType: "HEALTH",
    parentCode: "ACUTE_TOXICITY_INHALATION_DUSTS_AND_MISTS",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "ACUTE_TOXICITY",
    crosswalkNote: null,
  },
  {
    code: "ACUTE_TOXICITY_INHALATION_DUSTS_AND_MISTS_CATEGORY_2",
    label: "Acute Toxicity, Inhalation – Dusts and Mists – Category 2",
    hazardType: "HEALTH",
    parentCode: "ACUTE_TOXICITY_INHALATION_DUSTS_AND_MISTS",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "ACUTE_TOXICITY",
    crosswalkNote: null,
  },
  {
    code: "ACUTE_TOXICITY_INHALATION_DUSTS_AND_MISTS_CATEGORY_3",
    label: "Acute Toxicity, Inhalation – Dusts and Mists – Category 3",
    hazardType: "HEALTH",
    parentCode: "ACUTE_TOXICITY_INHALATION_DUSTS_AND_MISTS",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "ACUTE_TOXICITY",
    crosswalkNote: null,
  },
  {
    code: "ACUTE_TOXICITY_INHALATION_DUSTS_AND_MISTS_CATEGORY_4",
    label: "Acute Toxicity, Inhalation – Dusts and Mists – Category 4",
    hazardType: "HEALTH",
    parentCode: "ACUTE_TOXICITY_INHALATION_DUSTS_AND_MISTS",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "ACUTE_TOXICITY",
    crosswalkNote: null,
  },
  {
    code: "ASPIRATION_HAZARD",
    label: "Aspiration Hazard",
    hazardType: "HEALTH",
    parentCode: null,
    selectable: false,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "ASPIRATION_HAZARD",
    crosswalkNote: null,
  },
  {
    code: "ASPIRATION_HAZARD_CATEGORY_1",
    label: "Aspiration Hazard – Category 1",
    hazardType: "HEALTH",
    parentCode: "ASPIRATION_HAZARD",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "ASPIRATION_HAZARD",
    crosswalkNote: null,
  },
  {
    code: "CARCINOGENICITY",
    label: "Carcinogenicity",
    hazardType: "HEALTH",
    parentCode: null,
    selectable: false,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "CARCINOGENIC",
    crosswalkNote: null,
  },
  {
    code: "CARCINOGENICITY_CATEGORY_1",
    label: "Carcinogenicity – Category 1",
    hazardType: "HEALTH",
    parentCode: "CARCINOGENICITY",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "CARCINOGENIC",
    crosswalkNote: null,
  },
  {
    code: "CARCINOGENICITY_SUB_CATEGORY_1A",
    label: "Carcinogenicity – Sub-Category 1A",
    hazardType: "HEALTH",
    parentCode: "CARCINOGENICITY_CATEGORY_1",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "CARCINOGENIC",
    crosswalkNote: null,
  },
  {
    code: "CARCINOGENICITY_SUB_CATEGORY_1B",
    label: "Carcinogenicity – Sub-Category 1B",
    hazardType: "HEALTH",
    parentCode: "CARCINOGENICITY_CATEGORY_1",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "CARCINOGENIC",
    crosswalkNote: null,
  },
  {
    code: "CARCINOGENICITY_CATEGORY_2",
    label: "Carcinogenicity – Category 2",
    hazardType: "HEALTH",
    parentCode: "CARCINOGENICITY",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "CARCINOGENIC",
    crosswalkNote: null,
  },
  {
    code: "GERM_CELL_MUTAGENICITY",
    label: "Germ Cell Mutagenicity",
    hazardType: "HEALTH",
    parentCode: null,
    selectable: false,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "GERM_CELL_MUTAGENIC",
    crosswalkNote: null,
  },
  {
    code: "GERM_CELL_MUTAGENICITY_CATEGORY_1",
    label: "Germ Cell Mutagenicity – Category 1",
    hazardType: "HEALTH",
    parentCode: "GERM_CELL_MUTAGENICITY",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "GERM_CELL_MUTAGENIC",
    crosswalkNote: null,
  },
  {
    code: "GERM_CELL_MUTAGENICITY_SUB_CATEGORY_1A",
    label: "Germ Cell Mutagenicity – Sub-Category 1A",
    hazardType: "HEALTH",
    parentCode: "GERM_CELL_MUTAGENICITY_CATEGORY_1",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "GERM_CELL_MUTAGENIC",
    crosswalkNote: null,
  },
  {
    code: "GERM_CELL_MUTAGENICITY_SUB_CATEGORY_1B",
    label: "Germ Cell Mutagenicity – Sub-Category 1B",
    hazardType: "HEALTH",
    parentCode: "GERM_CELL_MUTAGENICITY_CATEGORY_1",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "GERM_CELL_MUTAGENIC",
    crosswalkNote: null,
  },
  {
    code: "GERM_CELL_MUTAGENICITY_CATEGORY_2",
    label: "Germ Cell Mutagenicity – Category 2",
    hazardType: "HEALTH",
    parentCode: "GERM_CELL_MUTAGENICITY",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "GERM_CELL_MUTAGENIC",
    crosswalkNote: null,
  },
  {
    code: "REPRODUCTIVE_TOXICITY",
    label: "Reproductive Toxicity",
    hazardType: "HEALTH",
    parentCode: null,
    selectable: false,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "REPRODUCTIVE_TOXICITY",
    crosswalkNote: null,
  },
  {
    code: "REPRODUCTIVE_TOXICITY_CATEGORY_1",
    label: "Reproductive Toxicity – Category 1",
    hazardType: "HEALTH",
    parentCode: "REPRODUCTIVE_TOXICITY",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "REPRODUCTIVE_TOXICITY",
    crosswalkNote: null,
  },
  {
    code: "REPRODUCTIVE_TOXICITY_SUB_CATEGORY_1A",
    label: "Reproductive Toxicity – Sub-Category 1A",
    hazardType: "HEALTH",
    parentCode: "REPRODUCTIVE_TOXICITY_CATEGORY_1",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "REPRODUCTIVE_TOXICITY",
    crosswalkNote: null,
  },
  {
    code: "REPRODUCTIVE_TOXICITY_SUB_CATEGORY_1B",
    label: "Reproductive Toxicity – Sub-Category 1B",
    hazardType: "HEALTH",
    parentCode: "REPRODUCTIVE_TOXICITY_CATEGORY_1",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "REPRODUCTIVE_TOXICITY",
    crosswalkNote: null,
  },
  {
    code: "REPRODUCTIVE_TOXICITY_CATEGORY_2",
    label: "Reproductive Toxicity – Category 2",
    hazardType: "HEALTH",
    parentCode: "REPRODUCTIVE_TOXICITY",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "REPRODUCTIVE_TOXICITY",
    crosswalkNote: null,
  },
  {
    code: "REPRODUCTIVE_TOXICITY_EFFECTS_ON_OR_VIA_LACTATION",
    label: "Reproductive Toxicity – Effects on or via lactation",
    hazardType: "HEALTH",
    parentCode: "REPRODUCTIVE_TOXICITY",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "REPRODUCTIVE_TOXICITY",
    crosswalkNote: null,
  },
  {
    code: "RESPIRATORY_SENSITIZER",
    label: "Respiratory Sensitizer",
    hazardType: "HEALTH",
    parentCode: null,
    selectable: false,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "CAUSES_RESPIRATORY_OR_SKIN_SENSITIZATION",
    crosswalkNote: null,
  },
  {
    code: "RESPIRATORY_SENSITIZER_CATEGORY_1",
    label: "Respiratory Sensitizer – Category 1",
    hazardType: "HEALTH",
    parentCode: "RESPIRATORY_SENSITIZER",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "CAUSES_RESPIRATORY_OR_SKIN_SENSITIZATION",
    crosswalkNote: null,
  },
  {
    code: "RESPIRATORY_SENSITIZER_SUB_CATEGORY_1A",
    label: "Respiratory Sensitizer – Sub-Category 1A",
    hazardType: "HEALTH",
    parentCode: "RESPIRATORY_SENSITIZER_CATEGORY_1",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "CAUSES_RESPIRATORY_OR_SKIN_SENSITIZATION",
    crosswalkNote: null,
  },
  {
    code: "RESPIRATORY_SENSITIZER_SUB_CATEGORY_1B",
    label: "Respiratory Sensitizer – Sub-Category 1B",
    hazardType: "HEALTH",
    parentCode: "RESPIRATORY_SENSITIZER_CATEGORY_1",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "CAUSES_RESPIRATORY_OR_SKIN_SENSITIZATION",
    crosswalkNote: null,
  },
  {
    code: "SKIN_SENSITIZER",
    label: "Skin Sensitizer",
    hazardType: "HEALTH",
    parentCode: null,
    selectable: false,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "CAUSES_RESPIRATORY_OR_SKIN_SENSITIZATION",
    crosswalkNote: null,
  },
  {
    code: "SKIN_SENSITIZER_CATEGORY_1",
    label: "Skin Sensitizer – Category 1",
    hazardType: "HEALTH",
    parentCode: "SKIN_SENSITIZER",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "CAUSES_RESPIRATORY_OR_SKIN_SENSITIZATION",
    crosswalkNote: null,
  },
  {
    code: "SKIN_SENSITIZER_SUB_CATEGORY_1A",
    label: "Skin Sensitizer – Sub-Category 1A",
    hazardType: "HEALTH",
    parentCode: "SKIN_SENSITIZER_CATEGORY_1",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "CAUSES_RESPIRATORY_OR_SKIN_SENSITIZATION",
    crosswalkNote: null,
  },
  {
    code: "SKIN_SENSITIZER_SUB_CATEGORY_1B",
    label: "Skin Sensitizer – Sub-Category 1B",
    hazardType: "HEALTH",
    parentCode: "SKIN_SENSITIZER_CATEGORY_1",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "CAUSES_RESPIRATORY_OR_SKIN_SENSITIZATION",
    crosswalkNote: null,
  },
  {
    code: "SERIOUS_EYE_DAMAGE",
    label: "Serious Eye Damage",
    hazardType: "HEALTH",
    parentCode: null,
    selectable: false,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "EYE_IRRITANT",
    crosswalkNote: null,
  },
  {
    code: "SERIOUS_EYE_DAMAGE_CATEGORY_1",
    label: "Serious Eye Damage – Category 1",
    hazardType: "HEALTH",
    parentCode: "SERIOUS_EYE_DAMAGE",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "EYE_IRRITANT",
    crosswalkNote: null,
  },
  {
    code: "EYE_IRRITATION",
    label: "Eye Irritation",
    hazardType: "HEALTH",
    parentCode: null,
    selectable: false,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "EYE_IRRITANT",
    crosswalkNote: null,
  },
  {
    code: "EYE_IRRITATION_CATEGORY_2",
    label: "Eye Irritation – Category 2",
    hazardType: "HEALTH",
    parentCode: "EYE_IRRITATION",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "EYE_IRRITANT",
    crosswalkNote: null,
  },
  {
    code: "EYE_IRRITATION_SUB_CATEGORY_2A",
    label: "Eye Irritation – Sub-Category 2A",
    hazardType: "HEALTH",
    parentCode: "EYE_IRRITATION_CATEGORY_2",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "EYE_IRRITANT",
    crosswalkNote: null,
  },
  {
    code: "EYE_IRRITATION_SUB_CATEGORY_2B",
    label: "Eye Irritation – Sub-Category 2B",
    hazardType: "HEALTH",
    parentCode: "EYE_IRRITATION_CATEGORY_2",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "EYE_IRRITANT",
    crosswalkNote: null,
  },
  {
    code: "SIMPLE_ASPHYXIANT",
    label: "Simple Asphyxiant",
    hazardType: "HEALTH",
    parentCode: null,
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "SIMPLE_ASPHYXIANT",
    crosswalkNote: null,
  },
  {
    code: "SKIN_CORROSION",
    label: "Skin Corrosion",
    hazardType: "HEALTH",
    parentCode: null,
    selectable: false,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "SKIN_IRRITANT",
    crosswalkNote: null,
  },
  {
    code: "SKIN_CORROSION_CATEGORY_1",
    label: "Skin Corrosion – Category 1",
    hazardType: "HEALTH",
    parentCode: "SKIN_CORROSION",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "SKIN_IRRITANT",
    crosswalkNote: null,
  },
  {
    code: "SKIN_CORROSION_SUB_CATEGORY_1A",
    label: "Skin Corrosion – Sub-Category 1A",
    hazardType: "HEALTH",
    parentCode: "SKIN_CORROSION_CATEGORY_1",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "SKIN_IRRITANT",
    crosswalkNote: null,
  },
  {
    code: "SKIN_CORROSION_SUB_CATEGORY_1B",
    label: "Skin Corrosion – Sub-Category 1B",
    hazardType: "HEALTH",
    parentCode: "SKIN_CORROSION_CATEGORY_1",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "SKIN_IRRITANT",
    crosswalkNote: null,
  },
  {
    code: "SKIN_CORROSION_SUB_CATEGORY_1C",
    label: "Skin Corrosion – Sub-Category 1C",
    hazardType: "HEALTH",
    parentCode: "SKIN_CORROSION_CATEGORY_1",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "SKIN_IRRITANT",
    crosswalkNote: null,
  },
  {
    code: "SKIN_IRRITATION",
    label: "Skin Irritation",
    hazardType: "HEALTH",
    parentCode: null,
    selectable: false,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "SKIN_IRRITANT",
    crosswalkNote: null,
  },
  {
    code: "SKIN_IRRITATION_CATEGORY_2",
    label: "Skin Irritation – Category 2",
    hazardType: "HEALTH",
    parentCode: "SKIN_IRRITATION",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "SKIN_IRRITANT",
    crosswalkNote: null,
  },
  {
    code: "SPECIFIC_TARGET_ORGAN_TOXICITY_SINGLE_EXPOSURE",
    label: "Specific Target Organ Toxicity Single Exposure",
    hazardType: "HEALTH",
    parentCode: null,
    selectable: false,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "SPECIFIC_TARGET_ORGAN_TOXICITY",
    crosswalkNote: null,
  },
  {
    code: "SPECIFIC_TARGET_ORGAN_TOXICITY_SINGLE_EXPOSURE_CATEGORY_1",
    label: "Specific Target Organ Toxicity Single Exposure – Category 1",
    hazardType: "HEALTH",
    parentCode: "SPECIFIC_TARGET_ORGAN_TOXICITY_SINGLE_EXPOSURE",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "SPECIFIC_TARGET_ORGAN_TOXICITY",
    crosswalkNote: null,
  },
  {
    code: "SPECIFIC_TARGET_ORGAN_TOXICITY_SINGLE_EXPOSURE_CATEGORY_2",
    label: "Specific Target Organ Toxicity Single Exposure – Category 2",
    hazardType: "HEALTH",
    parentCode: "SPECIFIC_TARGET_ORGAN_TOXICITY_SINGLE_EXPOSURE",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "SPECIFIC_TARGET_ORGAN_TOXICITY",
    crosswalkNote: null,
  },
  {
    code: "SPECIFIC_TARGET_ORGAN_TOXICITY_SINGLE_EXPOSURE_CATEGORY_3",
    label: "Specific Target Organ Toxicity Single Exposure – Category 3",
    hazardType: "HEALTH",
    parentCode: "SPECIFIC_TARGET_ORGAN_TOXICITY_SINGLE_EXPOSURE",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "SPECIFIC_TARGET_ORGAN_TOXICITY",
    crosswalkNote: null,
  },
  {
    code: "SPECIFIC_TARGET_ORGAN_TOXICITY_REPEATED_OR_PROLONGED_EXPOSURE",
    label: "Specific Target Organ Toxicity Repeated or Prolonged Exposure",
    hazardType: "HEALTH",
    parentCode: null,
    selectable: false,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "SPECIFIC_TARGET_ORGAN_TOXICITY",
    crosswalkNote: null,
  },
  {
    code: "SPECIFIC_TARGET_ORGAN_TOXICITY_REPEATED_OR_PROLONGED_EXPOSURE_CATEGORY_1",
    label: "Specific Target Organ Toxicity Repeated or Prolonged Exposure – Category 1",
    hazardType: "HEALTH",
    parentCode: "SPECIFIC_TARGET_ORGAN_TOXICITY_REPEATED_OR_PROLONGED_EXPOSURE",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "SPECIFIC_TARGET_ORGAN_TOXICITY",
    crosswalkNote: null,
  },
  {
    code: "SPECIFIC_TARGET_ORGAN_TOXICITY_REPEATED_OR_PROLONGED_EXPOSURE_CATEGORY_2",
    label: "Specific Target Organ Toxicity Repeated or Prolonged Exposure – Category 2",
    hazardType: "HEALTH",
    parentCode: "SPECIFIC_TARGET_ORGAN_TOXICITY_REPEATED_OR_PROLONGED_EXPOSURE",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "SPECIFIC_TARGET_ORGAN_TOXICITY",
    crosswalkNote: null,
  },
  {
    code: "HAZARD_NOT_OTHERWISE_CLASSIFIED_HEALTH",
    label: "Hazard Not Otherwise Classified (HNOC)",
    hazardType: "HEALTH",
    parentCode: null,
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: "HAZARD_NOT_OTHERWISE_CLASSIFIED_HEALTH",
    crosswalkNote: null,
  },
  {
    code: "AEROSOLS",
    label: "Aerosols",
    hazardType: "PHYSICAL",
    parentCode: null,
    selectable: false,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "FLAMMABLE",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "AEROSOLS_CATEGORY_1",
    label: "Aerosols – Category 1",
    hazardType: "PHYSICAL",
    parentCode: "AEROSOLS",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "FLAMMABLE",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "AEROSOLS_CATEGORY_2",
    label: "Aerosols – Category 2",
    hazardType: "PHYSICAL",
    parentCode: "AEROSOLS",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "FLAMMABLE",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "AEROSOLS_CATEGORY_3",
    label: "Aerosols – Category 3",
    hazardType: "PHYSICAL",
    parentCode: "AEROSOLS",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: null,
    crosswalkNote: "Formerly not classified or classified as Gas Under Pressure",
  },
  {
    code: "CHEMICALS_UNDER_PRESSURE",
    label: "Chemicals Under Pressure",
    hazardType: "PHYSICAL",
    parentCode: null,
    selectable: false,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "CHEMICALS_UNDER_PRESSURE_CATEGORY_1",
    label: "Chemicals Under Pressure – Category 1",
    hazardType: "PHYSICAL",
    parentCode: "CHEMICALS_UNDER_PRESSURE",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: null,
    crosswalkNote: "Formerly not classified or classified elsewhere.",
  },
  {
    code: "CHEMICALS_UNDER_PRESSURE_CATEGORY_2",
    label: "Chemicals Under Pressure – Category 2",
    hazardType: "PHYSICAL",
    parentCode: "CHEMICALS_UNDER_PRESSURE",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: null,
    crosswalkNote: "Formerly not classified or classified elsewhere.",
  },
  {
    code: "CHEMICALS_UNDER_PRESSURE_CATEGORY_3",
    label: "Chemicals Under Pressure – Category 3",
    hazardType: "PHYSICAL",
    parentCode: "CHEMICALS_UNDER_PRESSURE",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: null,
    legacyHealthHazard: null,
    crosswalkNote: "Formerly not classified or classified elsewhere.",
  },
  {
    code: "FLAMMABLE_GASES",
    label: "Flammable Gases",
    hazardType: "PHYSICAL",
    parentCode: null,
    selectable: false,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "FLAMMABLE",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "FLAMMABLE_GASES_CATEGORY_1A",
    label: "Flammable Gases – Category 1A",
    hazardType: "PHYSICAL",
    parentCode: "FLAMMABLE_GASES",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "FLAMMABLE",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "FLAMMABLE_GASES_CATEGORY_1B",
    label: "Flammable Gases – Category 1B",
    hazardType: "PHYSICAL",
    parentCode: "FLAMMABLE_GASES",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "FLAMMABLE",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "FLAMMABLE_GASES_CATEGORY_2",
    label: "Flammable Gases – Category 2",
    hazardType: "PHYSICAL",
    parentCode: "FLAMMABLE_GASES",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "FLAMMABLE",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "FLAMMABLE_GASES_CHEMICALLY_UNSTABLE_GAS",
    label: "Flammable Gases – Chemically Unstable Gas",
    hazardType: "PHYSICAL",
    parentCode: "FLAMMABLE_GASES",
    selectable: false,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "FLAMMABLE",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "FLAMMABLE_GASES_CHEMICALLY_UNSTABLE_GAS_CATEGORY_1A_A",
    label: "Flammable Gases – Chemically Unstable Gas – Category 1A/A",
    hazardType: "PHYSICAL",
    parentCode: "FLAMMABLE_GASES_CHEMICALLY_UNSTABLE_GAS",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "FLAMMABLE",
    legacyHealthHazard: null,
    crosswalkNote: "Formerly categorized as Flammable Gases – Category 1",
  },
  {
    code: "FLAMMABLE_GASES_CHEMICALLY_UNSTABLE_GAS_CATEGORY_1A_B",
    label: "Flammable Gases – Chemically Unstable Gas – Category 1A/B",
    hazardType: "PHYSICAL",
    parentCode: "FLAMMABLE_GASES_CHEMICALLY_UNSTABLE_GAS",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "FLAMMABLE",
    legacyHealthHazard: null,
    crosswalkNote: "Formerly categorized as Flammable Gases – Category 1",
  },
  {
    code: "FLAMMABLE_GASES_PYROPHORIC_GAS",
    label: "Flammable Gases – Pyrophoric Gas",
    hazardType: "PHYSICAL",
    parentCode: "FLAMMABLE_GASES",
    selectable: false,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "PYROPHORIC_GAS",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "FLAMMABLE_GASES_PYROPHORIC_GAS_CATEGORY_1A",
    label: "Flammable Gases – Pyrophoric Gas – Category 1A",
    hazardType: "PHYSICAL",
    parentCode: "FLAMMABLE_GASES_PYROPHORIC_GAS",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "PYROPHORIC_GAS",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "FLAMMABLE_LIQUIDS",
    label: "Flammable Liquids",
    hazardType: "PHYSICAL",
    parentCode: null,
    selectable: false,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "FLAMMABLE",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "FLAMMABLE_LIQUIDS_CATEGORY_1",
    label: "Flammable Liquids – Category 1",
    hazardType: "PHYSICAL",
    parentCode: "FLAMMABLE_LIQUIDS",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "FLAMMABLE",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "FLAMMABLE_LIQUIDS_CATEGORY_2",
    label: "Flammable Liquids – Category 2",
    hazardType: "PHYSICAL",
    parentCode: "FLAMMABLE_LIQUIDS",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "FLAMMABLE",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "FLAMMABLE_LIQUIDS_CATEGORY_3",
    label: "Flammable Liquids – Category 3",
    hazardType: "PHYSICAL",
    parentCode: "FLAMMABLE_LIQUIDS",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "FLAMMABLE",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "FLAMMABLE_LIQUIDS_CATEGORY_4",
    label: "Flammable Liquids – Category 4",
    hazardType: "PHYSICAL",
    parentCode: "FLAMMABLE_LIQUIDS",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "FLAMMABLE",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "FLAMMABLE_SOLIDS",
    label: "Flammable Solids",
    hazardType: "PHYSICAL",
    parentCode: null,
    selectable: false,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "FLAMMABLE",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "FLAMMABLE_SOLIDS_CATEGORY_1",
    label: "Flammable Solids – Category 1",
    hazardType: "PHYSICAL",
    parentCode: "FLAMMABLE_SOLIDS",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "FLAMMABLE",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "FLAMMABLE_SOLIDS_CATEGORY_2",
    label: "Flammable Solids – Category 2",
    hazardType: "PHYSICAL",
    parentCode: "FLAMMABLE_SOLIDS",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "FLAMMABLE",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "COMBUSTIBLE_DUST",
    label: "Combustible Dust",
    hazardType: "PHYSICAL",
    parentCode: null,
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "COMBUSTIBLE_DUST",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "CORROSIVE_TO_METAL",
    label: "Corrosive to Metal",
    hazardType: "PHYSICAL",
    parentCode: null,
    selectable: false,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "CORROSIVE_TO_METAL",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "CORROSIVE_TO_METAL_CATEGORY_1",
    label: "Corrosive to Metal – Category 1",
    hazardType: "PHYSICAL",
    parentCode: "CORROSIVE_TO_METAL",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "CORROSIVE_TO_METAL",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "DESENSITIZED_EXPLOSIVES",
    label: "Desensitized Explosives",
    hazardType: "PHYSICAL",
    parentCode: null,
    selectable: false,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "EXPLOSIVE",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "DESENSITIZED_EXPLOSIVES_CATEGORY_1",
    label: "Desensitized Explosives – Category 1",
    hazardType: "PHYSICAL",
    parentCode: "DESENSITIZED_EXPLOSIVES",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "EXPLOSIVE",
    legacyHealthHazard: null,
    crosswalkNote: "Formerly categorized as Explosives",
  },
  {
    code: "DESENSITIZED_EXPLOSIVES_CATEGORY_2",
    label: "Desensitized Explosives – Category 2",
    hazardType: "PHYSICAL",
    parentCode: "DESENSITIZED_EXPLOSIVES",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "EXPLOSIVE",
    legacyHealthHazard: null,
    crosswalkNote: "Formerly categorized as Explosives",
  },
  {
    code: "DESENSITIZED_EXPLOSIVES_CATEGORY_3",
    label: "Desensitized Explosives – Category 3",
    hazardType: "PHYSICAL",
    parentCode: "DESENSITIZED_EXPLOSIVES",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "EXPLOSIVE",
    legacyHealthHazard: null,
    crosswalkNote: "Formerly categorized as Explosives",
  },
  {
    code: "DESENSITIZED_EXPLOSIVES_CATEGORY_4",
    label: "Desensitized Explosives – Category 4",
    hazardType: "PHYSICAL",
    parentCode: "DESENSITIZED_EXPLOSIVES",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "EXPLOSIVE",
    legacyHealthHazard: null,
    crosswalkNote: "Formerly categorized as Explosives",
  },
  {
    code: "EXPLOSIVES",
    label: "Explosives",
    hazardType: "PHYSICAL",
    parentCode: null,
    selectable: false,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "EXPLOSIVE",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "EXPLOSIVES_UNSTABLE",
    label: "Explosives – Unstable",
    hazardType: "PHYSICAL",
    parentCode: "EXPLOSIVES",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "EXPLOSIVE",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "EXPLOSIVES_DIVISION_1_1",
    label: "Explosives – Division 1.1",
    hazardType: "PHYSICAL",
    parentCode: "EXPLOSIVES",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "EXPLOSIVE",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "EXPLOSIVES_DIVISION_1_2",
    label: "Explosives – Division 1.2",
    hazardType: "PHYSICAL",
    parentCode: "EXPLOSIVES",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "EXPLOSIVE",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "EXPLOSIVES_DIVISION_1_3",
    label: "Explosives – Division 1.3",
    hazardType: "PHYSICAL",
    parentCode: "EXPLOSIVES",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "EXPLOSIVE",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "EXPLOSIVES_DIVISION_1_4",
    label: "Explosives – Division 1.4",
    hazardType: "PHYSICAL",
    parentCode: "EXPLOSIVES",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "EXPLOSIVE",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "EXPLOSIVES_DIVISION_1_5",
    label: "Explosives – Division 1.5",
    hazardType: "PHYSICAL",
    parentCode: "EXPLOSIVES",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "EXPLOSIVE",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "EXPLOSIVES_DIVISION_1_6",
    label: "Explosives – Division 1.6",
    hazardType: "PHYSICAL",
    parentCode: "EXPLOSIVES",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "EXPLOSIVE",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "GAS_UNDER_PRESSURE",
    label: "Gas Under Pressure",
    hazardType: "PHYSICAL",
    parentCode: null,
    selectable: false,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "COMPRESSED_GAS",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "GAS_UNDER_PRESSURE_COMPRESSED_GAS",
    label: "Gas Under Pressure – Compressed Gas",
    hazardType: "PHYSICAL",
    parentCode: "GAS_UNDER_PRESSURE",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "COMPRESSED_GAS",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "GAS_UNDER_PRESSURE_DISSOLVED_GAS",
    label: "Gas Under Pressure – Dissolved Gas",
    hazardType: "PHYSICAL",
    parentCode: "GAS_UNDER_PRESSURE",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "COMPRESSED_GAS",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "GAS_UNDER_PRESSURE_LIQUEFIED_GAS",
    label: "Gas Under Pressure – Liquefied Gas",
    hazardType: "PHYSICAL",
    parentCode: "GAS_UNDER_PRESSURE",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "COMPRESSED_GAS",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "GAS_UNDER_PRESSURE_REFRIGERATED_LIQUEFIED_GAS",
    label: "Gas Under Pressure – Refrigerated liquefied gas",
    hazardType: "PHYSICAL",
    parentCode: "GAS_UNDER_PRESSURE",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "COMPRESSED_GAS",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "IN_CONTACT_WITH_WATER_EMITS_FLAMMABLE_GASES",
    label: "In Contact With Water Emits Flammable Gases",
    hazardType: "PHYSICAL",
    parentCode: null,
    selectable: false,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "FLAMMABLE_WITH_WATER",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "IN_CONTACT_WITH_WATER_EMITS_FLAMMABLE_GASES_CATEGORY_1",
    label: "In Contact With Water Emits Flammable Gases – Category 1",
    hazardType: "PHYSICAL",
    parentCode: "IN_CONTACT_WITH_WATER_EMITS_FLAMMABLE_GASES",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "FLAMMABLE_WITH_WATER",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "IN_CONTACT_WITH_WATER_EMITS_FLAMMABLE_GASES_CATEGORY_2",
    label: "In Contact With Water Emits Flammable Gases – Category 2",
    hazardType: "PHYSICAL",
    parentCode: "IN_CONTACT_WITH_WATER_EMITS_FLAMMABLE_GASES",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "FLAMMABLE_WITH_WATER",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "IN_CONTACT_WITH_WATER_EMITS_FLAMMABLE_GASES_CATEGORY_3",
    label: "In Contact With Water Emits Flammable Gases – Category 3",
    hazardType: "PHYSICAL",
    parentCode: "IN_CONTACT_WITH_WATER_EMITS_FLAMMABLE_GASES",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "FLAMMABLE_WITH_WATER",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "ORGANIC_PEROXIDES",
    label: "Organic Peroxides",
    hazardType: "PHYSICAL",
    parentCode: null,
    selectable: false,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "ORGANIC_PEROXIDE",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "ORGANIC_PEROXIDES_TYPE_A",
    label: "Organic Peroxides – Type A",
    hazardType: "PHYSICAL",
    parentCode: "ORGANIC_PEROXIDES",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "ORGANIC_PEROXIDE",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "ORGANIC_PEROXIDES_TYPE_B",
    label: "Organic Peroxides – Type B",
    hazardType: "PHYSICAL",
    parentCode: "ORGANIC_PEROXIDES",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "ORGANIC_PEROXIDE",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "ORGANIC_PEROXIDES_TYPE_C",
    label: "Organic Peroxides – Type C",
    hazardType: "PHYSICAL",
    parentCode: "ORGANIC_PEROXIDES",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "ORGANIC_PEROXIDE",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "ORGANIC_PEROXIDES_TYPE_D",
    label: "Organic Peroxides – Type D",
    hazardType: "PHYSICAL",
    parentCode: "ORGANIC_PEROXIDES",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "ORGANIC_PEROXIDE",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "ORGANIC_PEROXIDES_TYPE_E",
    label: "Organic Peroxides – Type E",
    hazardType: "PHYSICAL",
    parentCode: "ORGANIC_PEROXIDES",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "ORGANIC_PEROXIDE",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "ORGANIC_PEROXIDES_TYPE_F",
    label: "Organic Peroxides – Type F",
    hazardType: "PHYSICAL",
    parentCode: "ORGANIC_PEROXIDES",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "ORGANIC_PEROXIDE",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "ORGANIC_PEROXIDES_TYPE_G",
    label: "Organic Peroxides – Type G",
    hazardType: "PHYSICAL",
    parentCode: "ORGANIC_PEROXIDES",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "ORGANIC_PEROXIDE",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "OXIDIZING_GASES",
    label: "Oxidizing Gases",
    hazardType: "PHYSICAL",
    parentCode: null,
    selectable: false,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "OXIDIZER",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "OXIDIZING_GASES_CATEGORY_1",
    label: "Oxidizing Gases – Category 1",
    hazardType: "PHYSICAL",
    parentCode: "OXIDIZING_GASES",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "OXIDIZER",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "OXIDIZING_LIQUIDS",
    label: "Oxidizing Liquids",
    hazardType: "PHYSICAL",
    parentCode: null,
    selectable: false,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "OXIDIZER",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "OXIDIZING_LIQUIDS_CATEGORY_1",
    label: "Oxidizing Liquids – Category 1",
    hazardType: "PHYSICAL",
    parentCode: "OXIDIZING_LIQUIDS",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "OXIDIZER",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "OXIDIZING_LIQUIDS_CATEGORY_2",
    label: "Oxidizing Liquids – Category 2",
    hazardType: "PHYSICAL",
    parentCode: "OXIDIZING_LIQUIDS",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "OXIDIZER",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "OXIDIZING_LIQUIDS_CATEGORY_3",
    label: "Oxidizing Liquids – Category 3",
    hazardType: "PHYSICAL",
    parentCode: "OXIDIZING_LIQUIDS",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "OXIDIZER",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "OXIDIZING_SOLIDS",
    label: "Oxidizing Solids",
    hazardType: "PHYSICAL",
    parentCode: null,
    selectable: false,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "OXIDIZER",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "OXIDIZING_SOLIDS_CATEGORY_1",
    label: "Oxidizing Solids – Category 1",
    hazardType: "PHYSICAL",
    parentCode: "OXIDIZING_SOLIDS",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "OXIDIZER",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "OXIDIZING_SOLIDS_CATEGORY_2",
    label: "Oxidizing Solids – Category 2",
    hazardType: "PHYSICAL",
    parentCode: "OXIDIZING_SOLIDS",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "OXIDIZER",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "OXIDIZING_SOLIDS_CATEGORY_3",
    label: "Oxidizing Solids – Category 3",
    hazardType: "PHYSICAL",
    parentCode: "OXIDIZING_SOLIDS",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "OXIDIZER",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "PYROPHORIC_LIQUIDS",
    label: "Pyrophoric Liquids",
    hazardType: "PHYSICAL",
    parentCode: null,
    selectable: false,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "PYROPHORIC_SOLID_OR_LIQUID",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "PYROPHORIC_LIQUIDS_CATEGORY_1",
    label: "Pyrophoric Liquids – Category 1",
    hazardType: "PHYSICAL",
    parentCode: "PYROPHORIC_LIQUIDS",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "PYROPHORIC_SOLID_OR_LIQUID",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "PYROPHORIC_SOLIDS",
    label: "Pyrophoric Solids",
    hazardType: "PHYSICAL",
    parentCode: null,
    selectable: false,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "PYROPHORIC_SOLID_OR_LIQUID",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "PYROPHORIC_SOLIDS_CATEGORY_1",
    label: "Pyrophoric Solids – Category 1",
    hazardType: "PHYSICAL",
    parentCode: "PYROPHORIC_SOLIDS",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "PYROPHORIC_SOLID_OR_LIQUID",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "SELF_HEATING_CHEMICALS",
    label: "Self-Heating Chemicals",
    hazardType: "PHYSICAL",
    parentCode: null,
    selectable: false,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "SELF_HEATING",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "SELF_HEATING_CHEMICALS_CATEGORY_1",
    label: "Self-Heating Chemicals – Category 1",
    hazardType: "PHYSICAL",
    parentCode: "SELF_HEATING_CHEMICALS",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "SELF_HEATING",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "SELF_HEATING_CHEMICALS_CATEGORY_2",
    label: "Self-Heating Chemicals – Category 2",
    hazardType: "PHYSICAL",
    parentCode: "SELF_HEATING_CHEMICALS",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "SELF_HEATING",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "SELF_REACTIVE_CHEMICALS",
    label: "Self-Reactive Chemicals",
    hazardType: "PHYSICAL",
    parentCode: null,
    selectable: false,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "SELF_REACTIVE",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "SELF_REACTIVE_CHEMICALS_TYPE_A",
    label: "Self-Reactive Chemicals – Type A",
    hazardType: "PHYSICAL",
    parentCode: "SELF_REACTIVE_CHEMICALS",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "SELF_REACTIVE",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "SELF_REACTIVE_CHEMICALS_TYPE_B",
    label: "Self-Reactive Chemicals – Type B",
    hazardType: "PHYSICAL",
    parentCode: "SELF_REACTIVE_CHEMICALS",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "SELF_REACTIVE",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "SELF_REACTIVE_CHEMICALS_TYPE_C",
    label: "Self-Reactive Chemicals – Type C",
    hazardType: "PHYSICAL",
    parentCode: "SELF_REACTIVE_CHEMICALS",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "SELF_REACTIVE",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "SELF_REACTIVE_CHEMICALS_TYPE_D",
    label: "Self-Reactive Chemicals – Type D",
    hazardType: "PHYSICAL",
    parentCode: "SELF_REACTIVE_CHEMICALS",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "SELF_REACTIVE",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "SELF_REACTIVE_CHEMICALS_TYPE_E",
    label: "Self-Reactive Chemicals – Type E",
    hazardType: "PHYSICAL",
    parentCode: "SELF_REACTIVE_CHEMICALS",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "SELF_REACTIVE",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "SELF_REACTIVE_CHEMICALS_TYPE_F",
    label: "Self-Reactive Chemicals – Type F",
    hazardType: "PHYSICAL",
    parentCode: "SELF_REACTIVE_CHEMICALS",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "SELF_REACTIVE",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "SELF_REACTIVE_CHEMICALS_TYPE_G",
    label: "Self-Reactive Chemicals – Type G",
    hazardType: "PHYSICAL",
    parentCode: "SELF_REACTIVE_CHEMICALS",
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "SELF_REACTIVE",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
  {
    code: "HAZARD_NOT_OTHERWISE_CLASSIFIED_PHYSICAL",
    label: "Hazard Not Otherwise Classified (HNOC)",
    hazardType: "PHYSICAL",
    parentCode: null,
    selectable: true,
    effectiveFromRY: 2027,
    effectiveToRY: null,
    legacyPhysicalHazard: "UNCLASSIFIED_PHYSICAL_HAZARD",
    legacyHealthHazard: null,
    crosswalkNote: null,
  },
] as const satisfies readonly HazardCategoryRow[];

export type HazardCategoryCode = (typeof HAZARD_CATEGORIES)[number]["code"];
